//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Swiper from "swiper"
  import EsQuery from '@/javascript/esQuery'
  import util from '@/javascript/util'
  import mapList from '@/components/public-components/mapList/index.vue'
  import goBack from '@/components/public-components/goBack/index.vue'
  import Icn from './ich/newIndex.vue'
  import Footer from "@/components/lyx-components/lyx-footer/index"

  export default {
    components: {
      goBack,
      mapList,
      Footer,
      Icn
    },
    data() {
      return {
        tabData:['海晏非遗','时空图谱'],
        tabAct:0,
        bannerList: [],
        showMapList: false,
        infiniteStatus: false, //控制加载，true的话停止加载，false的话根据infiniteAll判断
        infiniteAll: false, //在infiniteStatus为false的情况下，infiniteAll为false停止加载，为true继续加载
        isShow: false,
        minHeight: 0,
        dataList: [],
        bannarList:[],
        pageNo: 0,
        PageSize: 7,
        guideData: {},
        indexName: this.INDEX_NAME_TYPE.heritage,
        codeMap: {
          '132001': {
            name: '世界级'
          },
          '132002': {
            name: '国家级'
          },
          '132003': {
            name: '省级'
          },
          '132004': {
            name: '州级'
          },
          '132005': {
            name: '县级'
          },
        }
      }
    },
    watch: {
    },
    mounted() {
      document.title = "非遗"
      this.minHeight = document.documentElement.clientHeight
      this.getSceneryList()
      this.getBannarList()
      window.addEventListener('scroll', this.windowScroll)
    },
    methods: {
      tabPage(index){
        this.tabAct=index
        if(index===0){
          this.getBannarList()
        }
      },
      getSceneryList() {
        const _this = this
        const querystring = require("querystring")
        const customEsQuery = new EsQuery()
        customEsQuery
          .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE,customEsQuery.and,false)
          .addSort("level", customEsQuery.asc, false)
          .addPage(_this.pageNo * _this.PageSize, _this.PageSize)
        const customJsonQuery = JSON.stringify(customEsQuery.getArray())
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: this.INDEX_NAME_TYPE.heritage,
              esJsonQuery: customJsonQuery,
            })
          )
          .then((res) => {
            let data = res.data.data
            _this.dataList = _this.dataList.concat(data)
            if (res.data.data.length < _this.PageSize) {
              _this.infiniteAll = true
            }
            _this.infiniteStatus = false
          })
      },
      getBannarList () {
        const videoList = new EsQuery()
        const querystring = require('querystring')
        // videoList.addString("catalogId", 'e6825cf320e94b35b81b67b14c9a82cd', videoList.and, false)
          // .addStartWith("catalogCode", '00000000,1670828003124,1715740958692', videoList.and, false)
          videoList.addSort("weight", videoList.desc, false)
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, videoList.and, false)
          .addString('heritageSerial', '1', videoList.and, false)
          .addPage(0, 100)
        const video = JSON.stringify(videoList.getArray())
        this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
          'indexName': this.INDEX_NAME_TYPE.heritage,
          'esJsonQuery': video
        })).then((res) => {
          this.bannarList = res.data.data
          this.$nextTick(() => {
            new Swiper('.wen-swiper', {
              loop: false,
              autoplay: 5000,
              slidesPerView: 1,
              spaceBetween: 10,
              observer: true,
              observeParents: true,
          })
          })
        })
      },
      goMap(item){
        this.guideData = { longitude: +item._source.longitude,latitude: +item._source.latitude, title: item._source.address }
        if (util.isWxMini()) {
          wx.miniProgram.navigateTo({
            url: `/pages/map/index?location=${JSON.stringify(this.guideData)}`,
          })
        }else{
          this.showMapList = true
        }
      },
      goDetails(item){
        this.$router.push({ path:`/legacyDetail?id=${item._source.id}&tags=${this.codeMap[item._source.level].name}`})
      },
       //监听滚动
      windowScroll(e) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
            this.isShow = true
        } else {
            this.isShow = false
        }
        // 底部加载
        if (util.pullUpLoad()) {
            this.infinite()
        }
      },
       // 初始化分页
      infinite: function () {
        if (this.dataList.length == 0) {
            return;
        }
        if (this.infiniteAll) {
            return;
        }
        if (this.infiniteStatus) {
            return;
        }
        this.infiniteStatus = true;
        this.pageNo += 1;
        this.getSceneryList();
      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.windowScroll)
    },
  }
  